function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
import VectorImage from '../vectorImage/VectorImage';
import { VECTOR_IMAGE_PAYMENT } from '../vectorImage/constants';
import * as constants from './constants';
import { getPaymentIconSizeHeight, getPaymentIconSizeWidth } from './util';

var PaymentIcon =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PaymentIcon, _PureComponent);

  function PaymentIcon() {
    _classCallCheck(this, PaymentIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(PaymentIcon).apply(this, arguments));
  }

  _createClass(PaymentIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          size = _this$props.size,
          title = _this$props.title;
      var INLINE_STYLES = {
        height: getPaymentIconSizeHeight(size),
        width: getPaymentIconSizeWidth(size)
      };
      var svg = React.cloneElement(type, {
        style: INLINE_STYLES
      });
      return React.createElement(VectorImage, {
        type: VECTOR_IMAGE_PAYMENT,
        svg: svg,
        title: title
      });
    }
  }]);

  return PaymentIcon;
}(PureComponent);

_defineProperty(PaymentIcon, "propTypes", {
  /**
   * The type of payment icon that you want to display e.g. Visa
   */
  type: constants.PAYMENT_TYPE_PROP_TYPE.isRequired,

  /**
   * The size of the icon
   */
  size: PropTypes.oneOf(constants.PAYMENT_ICON_SIZES),

  /**
   * Add a title attribute to the to icons markup
   */
  title: EBPropTypes.translation
});

_defineProperty(PaymentIcon, "defaultProps", {
  size: 'medium'
});

export { PaymentIcon as default };